import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { logout, clearAuthToken } from '../api';

export default function Layout({ user, setUser }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout().catch(() => {});
    clearAuthToken();
    setUser(null);
    navigate('/login');
  };

  return (
    <div className="min-vh-100 bg-light">
      <nav className="navbar navbar-expand-lg modern-navbar px-4 py-2 sticky-top">
        <span className="navbar-brand fw-bold" style={{ color: '#0f172a' }}>
          <i className="bi bi-hdd-network-fill me-2 fs-4 align-middle text-primary"/>Server Management
        </span>
        <div className="collapse navbar-collapse ms-4">
          <ul className="navbar-nav me-auto gap-1">
            <li className="nav-item"><NavLink className="nav-link" to="/server-management">Dashboard</NavLink></li>
            <li className="nav-item"><NavLink className="nav-link" to="/cloud-server-ip">Cloud IPs</NavLink></li>
            <li className="nav-item"><NavLink className="nav-link" to="/update-server-details">Update Details</NavLink></li>
          </ul>
        </div>
        <div className="d-flex align-items-center gap-3">
          <span className="text-secondary fw-medium"><i className="bi bi-person-circle me-2"/>{user?.userName}</span>
          <button className="btn btn-light border text-danger py-1 px-3 d-flex align-items-center" onClick={handleLogout}>
            <i className="bi bi-box-arrow-right me-2"/>Logout
          </button>
        </div>
      </nav>
      <div className="container-fluid p-4" style={{ maxWidth: '1600px', margin: '0 auto' }}>
        <Outlet />
      </div>
    </div>
  );
}
